import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";

export function ClipboardScoreNeverNoShowHeader() {
  return (
    <Stack spacing={1}>
      <PageHeaderTopRow />
      <Box sx={{ paddingX: 7, paddingBottom: 7 }}>
        <Text bold variant="h4">
          How No Shows Work
        </Text>
      </Box>
    </Stack>
  );
}
